import { atom } from 'jotai';

/** Après import datasource : demander si l’utilisateur veut inclure les produits exclus mis à jour. */
export type DatasourceExcludedUpdatedPrompt = {
  dealId: string;
  dealItemIds: string[];
} | null;

export const datasourceExcludedUpdatedPromptState =
  atom<DatasourceExcludedUpdatedPrompt>(null);
